import React from 'react';
import { SvgIcon, SvgIconProps, useTheme } from '@material-ui/core';

export default function FacilityTypeColored(props: SvgIconProps) {
  const { palette } = useTheme();
  const accentColor = palette.success.main;

  return (
    <SvgIcon {...props}>
      <path d="M18.2197 3.98142H5.76107C4.78218 3.98142 3.99016 4.78233 3.99016 5.76122L3.98126 18.2198C3.98126 19.1987 4.78218 19.9996 5.76107 19.9996H18.2197C19.1986 19.9996 19.9995 19.1987 19.9995 18.2198V5.76122C19.9995 4.78233 19.1986 3.98142 18.2197 3.98142ZM18.2197 18.2198H5.76107V5.76122H18.2197V18.2198Z" />
      <path
        d="M13.3254 16.44H10.6557V13.3254H7.54102V10.6557H10.6557V7.54102H13.3254V10.6557H16.44V13.3254H13.3254V16.44Z"
        fill={accentColor}
      />
    </SvgIcon>
  );
}
